export enum AdobeEventActions {
  APPLICATION_LOADED = "Application Loaded",
  EMAIL_CONFIGURATION = "Email Configuration",
  DOWNLOAD_CONFIGURATION = "Download Configuration",
  MODEL_SELECTED = "Model Selected",
  SUBSTEP_COMPLETED = "SubStep Completed",
  IMAGE_MODE_TOGGLED = "Image Mode Toggled",
  VIEW_360_OPENED = "360 View Opened",
  VIEW_360_CLOSED = "360 View Closed",
  SEGMENT_SELECTED = "Segment Selected",
  OPTION_EVALUATED = "Option Evaluated",
  SUMMARY_REACHED = "Summary Reached",
  FORM_SUBMIT = "Form Submit",
  FORM_START = "Form Start",
  CTA_CONTACT_DEALER = "CTA: Contact a Dealer",
  CTA_EMAIL_CONFIGURATION_OPEN_FORM = "CTA: Email Configuration (Open Form)",
  CTA_SHARE = "CTA: Share",
  FULL_SCREEN_360_ENABLED = "360 Full Screen Enabled",
  FULL_SCREEN_360_DISABLED = "360 Full Screen Disabled",
  IMAGE_CHANGED = "Image Changed",
  SHOW_MORE = "Show More",
  SHOW_LESS = "Show Less",
}

export const actionSelcted = (group: string) =>
  `${group} Selected`;